// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"16":"4255658d","724":"33e5a95b"}[chunkId] || chunkId) + "." + {"16":"a7792a575689a057","271":"7bec72a86f65451c","724":"ce521eefbca437ad"}[chunkId] + ".js";
};